export const isProd = Boolean(window.location.hostname === "app.wayflyer.com");
